import { render, staticRenderFns } from "./type21.vue?vue&type=template&id=6b6de08b&scoped=true"
import script from "./type21.vue?vue&type=script&lang=js"
export * from "./type21.vue?vue&type=script&lang=js"
import style0 from "./type21.vue?vue&type=style&index=0&id=6b6de08b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6de08b",
  null
  
)

export default component.exports